import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initTheme } from './utils/theme';
import { captureInstallPrompt } from './components/InstallAppButton';

// 첫 그림이 그려지기 전에 적용한다 — 나중에 걸면 화면이 한 번 번쩍인다
initTheme();

/**
 * **사이트 어디서도 끌기(네이티브 드래그)가 일어나지 않게 한다.**
 *
 * 그림·링크는 브라우저가 기본으로 끌 수 있게 두어서, 살짝만 끌어도 반투명 유령 그림이
 * 따라붙는다. 보기에 지저분한 데다 방덱을 손잡이로 옮기는 중에 끼어들어 끌기를 끊는다.
 *
 * CSS 로도 막지만(`App.css` 의 `-webkit-user-drag`) 파이어폭스는 그 속성을 모른다. 그래서
 * 여기서 `dragstart` 를 한 번에 막는다 — 화면마다 `draggable={false}` 를 붙이면 반드시
 * 빠뜨리는 곳이 생긴다.
 */
document.addEventListener('dragstart', (e) => e.preventDefault());

// 홈 화면 추가 창(beforeinstallprompt)은 페이지가 뜨자마자 한 번 온다 — 서랍 단추가 그려지기 전에 받아 둔다
captureInstallPrompt();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
